import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_layout/tasks/_layout/recommendations')({
  component: () => null,
});